var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-342.000000, -120.000000)",
    fill: "#151B22",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.969555,103.99061 C339.250587,103.99061 339.492583,104.092331 339.69555,104.295775 C339.898518,104.499219 340,104.726133 340,104.976526 L340,120 L335.971897,116.00939 L325.01171,116.00939 C324.730678,116.00939 324.488682,115.907669 324.285714,115.704225 C324.082747,115.500781 323.981265,115.273867 323.981265,115.023474 L323.981265,114.004695 L338.002342,114.004695 L338.002342,103.99061 L338.969555,103.99061 Z M335.004684,100 C335.25449,100 335.480873,100.093896 335.683841,100.28169 C335.886808,100.469485 335.98829,100.704224 335.98829,100.985915 L335.98829,111 C335.98829,111.281692 335.886808,111.516431 335.683841,111.704225 C335.480873,111.89202 335.25449,111.985915 335.004684,111.985915 L323.981265,111.985915 L320,116.023474 L320,100.985915 C320,100.704224 320.101482,100.469485 320.30445,100.28169 C320.507417,100.093896 320.7338,100 320.983607,100 L335.004684,100 Z M334,102 L322,102 L322,110 L334,110 L334,102 Z",
    id: "Message"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.f3a27739.svg";
export { ForwardRef as ReactComponent };